export default class utility {
    constructor() {
        this._platformClasses();
        this._blankRemoval();
        this._checkTab();
    }

    _platformClasses() {
        $('html').addClass('browser' + '-' + platform.name.toLowerCase().replace(/\s+/g, '-'));
        $('html').addClass('os' + '-' + platform.os.family.toLowerCase().replace(/\s+/g, '-').replace(/[^a-zA-Z 0-9 -]+/g, ''));
        $('html').addClass('browser-version' + '-' + platform.name.toLowerCase().replace(/\s+/g, '-') + '-' + platform.version.toLowerCase().replace(/\s+/g, '-'));
    }

    _blankRemoval() {
        $('[target="_blank"]').attr('target', '_self');
    }

    _checkTab() {
        $('body').on('keyup.tabwatcher', function(e) {
            if (e.which == 9) {
                e.preventDefault();
                $('body').addClass('has-tabbed');
                $('body').off('keyup.tabwatcher')
            }
        });
    }

}